





































import { Component, Vue } from 'vue-property-decorator';
import config from '@/config/local';

@Component({
	name: 'DashboardHeader'
})
export default class DashboardHeader extends Vue {
	/* Data
	============================================*/
	documentationURL: string = config.DOCUMENTATION_URL;

	/* Computed
	============================================*/
	get hasDocumentationURL(): boolean {
		return this.documentationURL !== '' && this.documentationURL !== undefined;
	}
}
